module.exports = __webpack_public_path__ + "assets/none.e42c6a99.png";